
export default class Mimetypes {

    static mimetype2suffix = {
        'image/png': 'png',
        'image/jpeg': 'jpg',
        'image/webp': 'webp',
    }

    static suffix2mimetype = {
        'png': 'image/png',
        'jpg': 'image/jpeg',
        'webp': 'image/webp',
    }

    /** */
    static getMimetypeOfFilename(filename) {
        return Mimetypes.suffix2mimetype[filename.substringAfterLast('.')];
    }

    /** */
    static getSuffixOfMimetype(mimetype) {
        return Mimetypes.mimetype2suffix[mimetype];

    }

}
